module.exports = __webpack_public_path__ + "static/media/sparkles.fadc7b2d.svg";